import { render, staticRenderFns } from "./EditApprovalDialog.vue?vue&type=template&id=34bd6c01"
import script from "./EditApprovalDialog.vue?vue&type=script&lang=js"
export * from "./EditApprovalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports